
import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog } from '@/components/ui/dialog';
import { ProductSelectorDialog } from './product-selector';
import { useProductSelector } from './product-selector/useProductSelector';
import { PlusCircle } from 'lucide-react';

interface OrderProductSelectorProps {
  onAddProduct: (product: any) => void;
  shopId?: string;
}

const OrderProductSelector = ({ onAddProduct, shopId }: OrderProductSelectorProps) => {
  const [open, setOpen] = useState(false);
  
  console.log('ProductSelector component - shopId:', shopId);

  useEffect(() => {
    console.log('ProductSelector initialized with shopId:', shopId);
  }, [shopId]);
  
  const {
    loading,
    error,
    searchTerm,
    setSearchTerm,
    filteredProducts,
    selectedProduct,
    setSelectedProduct,
    quantity,
    setQuantity,
    showCustomProduct,
    setShowCustomProduct,
    productName,
    setProductName,
    productPrice,
    setProductPrice,
    handleAddProduct
  } = useProductSelector(
    onAddProduct, 
    () => setOpen(false),
    shopId
  );

  return (
    <>
      <Button
        onClick={() => {
          console.log('Opening product selector with shopId:', shopId);
          setOpen(true);
        }}
        className="w-full add-button"
        data-testid="add-product-button"
      >
        <PlusCircle className="h-4 w-4 mr-2" />
        Ajouter un produit
      </Button>
      
      <Dialog open={open} onOpenChange={(newOpen) => {
        console.log('Dialog open state changing to:', newOpen, 'shopId:', shopId);
        setOpen(newOpen);
      }}>
        <ProductSelectorDialog
          loading={loading}
          error={error}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          filteredProducts={filteredProducts}
          selectedProduct={selectedProduct}
          setSelectedProduct={setSelectedProduct}
          quantity={quantity}
          setQuantity={setQuantity}
          showCustomProduct={showCustomProduct}
          setShowCustomProduct={setShowCustomProduct}
          productName={productName}
          setProductName={setProductName}
          productPrice={productPrice}
          setProductPrice={setProductPrice}
          onAddProduct={handleAddProduct}
        />
      </Dialog>
    </>
  );
};

export default OrderProductSelector;
